module.exports = __webpack_public_path__ + "img/1597.5db129da.gif";